import { render, staticRenderFns } from "./SelectStatusSale.vue?vue&type=template&id=0b43b30f&scoped=true&"
import script from "./SelectStatusSale.vue?vue&type=script&lang=js&"
export * from "./SelectStatusSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43b30f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
